export default "__VITE_ASSET__Ckg6a_6g__"